import React from "react";
import styled from "styled-components/native";
import { useTheme } from "styled-components/native";
import { Spacer, VDBText } from "../..";
import { useTypographyStore } from "@redux/slices/typographySlice";
import { SpaceType } from "@components/atoms/Spacer/types";
import { getProductAttributes } from "@utils/index";
import { useProducts } from "@redux/slices/globalSlice";
import { useTranslation } from "react-i18next";
import { StoneType } from "@scenes/bulk-request/Utils";
import { DefaultTheme } from "styled-components/native";

type TextSearchProductProps = {
  productId: string;
  subProductTypeCategory?: string;
  showResultsAsTooltip?: boolean;
  paddingTop?: number;
  noPadding?: boolean;
};

const TextSearchProductType = ({
  productId,
  subProductTypeCategory,
  showResultsAsTooltip,
  noPadding = false,
}: TextSearchProductProps) => {
  const theme = useTheme();
  const typography = useTypographyStore();
  const allProducts = useProducts();
  const { t } = useTranslation();

  return (
    <HeaderContainer
      showResultsAsTooltip={showResultsAsTooltip}
      noPadding={noPadding}
    >
      {!showResultsAsTooltip && <Spacer size={SpaceType.Small} />}
      <ItemTypeView productId={productId}>
        <VDBText
          type={{ ...typography["Minor-M"], lineHeight: 12 }}
          color={getProductAttributes(allProducts, productId, theme).color}
        >
          {`${t(getProductAttributes(allProducts, productId, theme).text)} ${
            subProductTypeCategory === StoneType.PAIR
              ? t("productDetail.pair.text", "Pairs")
              : subProductTypeCategory === StoneType.PARCELS
              ? t("productDetail.parcels.text", "Parcels")
              : ""
          }`}
        </VDBText>
      </ItemTypeView>
    </HeaderContainer>
  );
};

const ItemTypeView = styled.View<{
  productId: string;
}>`
  align-self: flex-start;
  background-color: ${({
    theme,
    productId,
  }: {
    theme: DefaultTheme;
    productId: string;
  }) =>
    productId === "0"
      ? theme["diam-03"]
      : productId === "1"
      ? theme["lab-03"]
      : productId === "2"
      ? theme["gem-03"]
      : theme["jewelry-03"]};
  padding: 6px;
  border-radius: 4px;
`;

const HeaderContainer = styled.View<{
  showResultsAsTooltip?: boolean;
  paddingTop?: number;
}>`
  width: 100%;
  padding-top: ${({ noPadding }: { noPadding?: boolean }) =>
    noPadding ? 0 : 16}px;
  padding-left: ${({
    showResultsAsTooltip,
    noPadding,
  }: {
    showResultsAsTooltip?: boolean;
    noPadding?: boolean;
  }) => (showResultsAsTooltip ? 0 : noPadding ? 0 : 16)}px;
  background-color: ${({ theme }: { theme: DefaultTheme }) => theme["core-02"]};
`;

export default TextSearchProductType;
